const nationalPath = 'national-2/national-2'

const fonts = [
  {
    id: 'sb-font-national-2-regular',
    path: `${nationalPath}-regular/national-2-regular`,
  },
  {
    id: 'sb-font-national-2-medium',
    path: `${nationalPath}-medium/national-2-medium`,
  },
  {
    id: 'sb-font-national-2-bold',
    path: `${nationalPath}-bold/national-2-bold`,
  },
]

const fontLinkTemplate = (font: Font) =>
  `<link id="${font.id}" rel="preload" as="font" href="https://www.which.co.uk/global/fonts/${font.path}.woff2" type="font/woff2" crossorigin="anonymous" />`

export const preloadFonts = () => {
  // Load the font and avoid reloading it when components change
  fonts.forEach(
    (font) =>
      !document.getElementById(font.id) &&
      document.head.insertAdjacentHTML('afterbegin', fontLinkTemplate(font))
  )
}

export const preloadFontsForServerSide = fonts.map((font) => fontLinkTemplate(font))

///////// IMPLEMENTATION /////////

type Font = {
  id: string
  path: string
}
